var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "searchBox_top" },
        [
          _vm.createParams.status != "submit"
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v(_vm._s(_vm.$t("common.submit")) + " ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "createParams",
          attrs: {
            model: _vm.createParams,
            rules: _vm.rules,
            "label-width": "130px",
            disabled: _vm.createParams.status == "submit",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.createDate"),
                        prop: "createDate",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", disabled: "" },
                        model: {
                          value: _vm.createParams.createDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "createDate",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.createDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.createBy"),
                        prop: "creator",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", disabled: "" },
                        model: {
                          value: _vm.createParams.creator,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "creator",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.creator",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("common.status"), prop: "status" },
                    },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TT_ENGAGEMENT",
                          field: "STATUS",
                          disabled: "",
                        },
                        model: {
                          value: _vm.createParams.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "status", $$v)
                          },
                          expression: "createParams.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("settlementUnit.SystemApplyNo"),
                        prop: "serialNo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", disabled: "" },
                        model: {
                          value: _vm.createParams.serialNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "serialNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.serialNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("Supplier Information")])]
              ),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _vm._v(
                    "1. Full Legal Name of the Supplier (in both Chinese and English)"
                  ),
                ]
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Chinese Name", prop: "nameCn" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.createParams.nameCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "nameCn", $$v)
                          },
                          expression: "createParams.nameCn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "English Name", prop: "nameEn" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.createParams.nameEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "nameEn", $$v)
                          },
                          expression: "createParams.nameEn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider"),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _vm._v(
                    "2. Legal Entities to be covered by BRA (e.g., MCCL, CTC)"
                  ),
                ]
              ),
              _c(
                "el-row",
                { staticClass: "noLeft" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: "",
                          clearable: "",
                          maxlength: "300",
                          rows: "3",
                        },
                        model: {
                          value: _vm.createParams.affiliates,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "affiliates", $$v)
                          },
                          expression: "createParams.affiliates",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "noLeft" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.enclosure"),
                            prop: "tmLawFileId",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticStyle: { float: "left" },
                              attrs: {
                                action: "upload",
                                "http-request": _vm.uploadConfirm,
                                "show-file-list": false,
                                multiple: "",
                                name: "file",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    size: "small",
                                    type: "primary",
                                  },
                                  slot: "trigger",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.selectFile")) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.fileList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "padding-bottom": "5px" },
                          },
                          [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadFile(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.documentName))]
                            ),
                            _c("el-button", {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-delete",
                                circle: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.deleteFile(
                                    item.tmDocumentId,
                                    index,
                                    _vm.fileList
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c("el-divider"),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v("3. Product(s) to be Supplied"),
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "productType" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function ($event) {
                          _vm.productContent = null
                          _vm.nonProductContent = null
                        },
                      },
                      model: {
                        value: _vm.createParams.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.createParams, "productType", $$v)
                        },
                        expression: "createParams.productType",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-radio", { attrs: { label: "P" } }, [
                            _vm._v("Protein"),
                          ]),
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.productContent,
                              callback: function ($$v) {
                                _vm.productContent = $$v
                              },
                              expression: "productContent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-radio", { attrs: { label: "N" } }, [
                            _vm._v("Non Protein"),
                          ]),
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.nonProductContent,
                              callback: function ($$v) {
                                _vm.nonProductContent = $$v
                              },
                              expression: "nonProductContent",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider"),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(
                    "4. List the provinces to receive products from this supplier"
                  ),
                ]
              ),
              _c(
                "el-row",
                { staticClass: "noLeft" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "provinces" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: "",
                          clearable: "",
                          maxlength: "300",
                        },
                        model: {
                          value: _vm.createParams.provinces,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "provinces", $$v)
                          },
                          expression: "createParams.provinces",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v("5. Expected Supply Period (when applicable)"),
                ]
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Start Date",
                        prop: "startDate",
                        "label-width": "170px",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          "picker-options": _vm.pickerOptionsStart,
                          placeholder: _vm.$t("common.selDate"),
                        },
                        model: {
                          value: _vm.createParams.startDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "startDate", $$v)
                          },
                          expression: "createParams.startDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "End Date (if relevant)",
                        prop: "endDate",
                        "label-width": "170px",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          "picker-options": _vm.pickerOptionsEnd,
                          placeholder: _vm.$t("common.selDate"),
                        },
                        model: {
                          value: _vm.createParams.endDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.createParams, "endDate", $$v)
                          },
                          expression: "createParams.endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider"),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(
                    "6. Required Qualification Documentation (scanned copies to be sent to Legal together with the completed form)"
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "licenseWithChop" },
                },
                [
                  _c("span", { staticStyle: { width: "500px" } }, [
                    _vm._v(
                      "a. Business License of the Supplier (with the company chop)"
                    ),
                  ]),
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticStyle: { float: "left" },
                      attrs: {
                        action: "upload",
                        "http-request": _vm.uploadConfirm1,
                        "show-file-list": false,
                        multiple: "",
                        name: "file",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.selectFile")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.fileList1, function (item, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticStyle: {
                      "padding-bottom": "5px",
                      "margin-right": "40px",
                    },
                  },
                  [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.downloadFile(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.documentName))]
                    ),
                    _c("el-button", {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        type: "danger",
                        size: "mini",
                        icon: "el-icon-delete",
                        circle: "",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteFile(
                            item.tmDocumentId,
                            index,
                            _vm.fileList1
                          )
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "certificateWithChop" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c("span", { staticStyle: { width: "500px" } }, [
                        _vm._v(
                          "b. Production/Operation Certificate or equivalent (with the company chop)"
                        ),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.certificateWithChopChange },
                          model: {
                            value: _vm.createParams.certificateWithChop,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.createParams,
                                "certificateWithChop",
                                $$v
                              )
                            },
                            expression: "createParams.certificateWithChop",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "20px" },
                              attrs: { label: "Y" },
                            },
                            [_vm._v("Y")]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "20px" },
                              attrs: { label: "N" },
                            },
                            [_vm._v("N")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticStyle: { "margin-left": "70px" },
                          attrs: {
                            action: "upload",
                            "http-request": _vm.uploadConfirm2,
                            "show-file-list": false,
                            multiple: "",
                            name: "file",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.selectFile")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.fileList2, function (item, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticStyle: {
                      "padding-bottom": "5px",
                      "margin-right": "40px",
                    },
                  },
                  [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.downloadFile(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.documentName))]
                    ),
                    _c("el-button", {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        type: "danger",
                        size: "mini",
                        icon: "el-icon-delete",
                        circle: "",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteFile(
                            item.tmDocumentId,
                            index,
                            _vm.fileList2
                          )
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "processWithChop" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c("span", { staticStyle: { width: "500px" } }, [
                        _vm._v(
                          "c. Importation Registration Process Completed (for imported food)"
                        ),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.processWithChopChange },
                          model: {
                            value: _vm.createParams.processWithChop,
                            callback: function ($$v) {
                              _vm.$set(_vm.createParams, "processWithChop", $$v)
                            },
                            expression: "createParams.processWithChop",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "20px" },
                              attrs: { label: "Y" },
                            },
                            [_vm._v("Y")]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "20px" },
                              attrs: { label: "N" },
                            },
                            [_vm._v("N")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticStyle: { "margin-left": "70px" },
                          attrs: {
                            action: "upload",
                            "http-request": _vm.uploadConfirm3,
                            "show-file-list": false,
                            multiple: "",
                            name: "file",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.selectFile")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.fileList3, function (item, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticStyle: {
                      "padding-bottom": "5px",
                      "margin-right": "40px",
                    },
                  },
                  [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.downloadFile(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.documentName))]
                    ),
                    _c("el-button", {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        type: "danger",
                        size: "mini",
                        icon: "el-icon-delete",
                        circle: "",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteFile(
                            item.tmDocumentId,
                            index,
                            _vm.fileList3
                          )
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _c("el-divider"),
              _c(
                "span",
                { staticStyle: { "margin-bottom": "10px", display: "block" } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v("7. Required Information in the BRA"),
                ]
              ),
              _c("div", { staticStyle: { "padding-bottom": "10px" } }, [
                _vm._v(
                  "a. Supplier’s Business Contact (name, email address and phone number) "
                ),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "contactName", label: "Name" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.createParams.contactName,
                      callback: function ($$v) {
                        _vm.$set(_vm.createParams, "contactName", $$v)
                      },
                      expression: "createParams.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "contactEmail", label: "Email" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.createParams.contactEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.createParams, "contactEmail", $$v)
                      },
                      expression: "createParams.contactEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "contactPhone", label: "Address" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.createParams.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.createParams, "contactPhone", $$v)
                      },
                      expression: "createParams.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "padding-bottom": "10px" } }, [
                _vm._v(
                  "b. Signatory on behalf of the Supplier (if not the Legal Representative) "
                ),
              ]),
              _c(
                "el-form-item",
                { staticClass: "noLeft flexBox", attrs: { prop: "signatory" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.createParams.signatory,
                      callback: function ($$v) {
                        _vm.$set(_vm.createParams, "signatory", $$v)
                      },
                      expression: "createParams.signatory",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "padding-bottom": "10px" } }, [
                _vm._v("c. Title of the Signatory of BRA"),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "signatoryTitle" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.createParams.signatoryTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.createParams, "signatoryTitle", $$v)
                      },
                      expression: "createParams.signatoryTitle",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "padding-bottom": "10px" } }, [
                _vm._v("d. Registered Address"),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "noLeft flexBox",
                  attrs: { prop: "registAddress" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.createParams.registAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.createParams, "registAddress", $$v)
                      },
                      expression: "createParams.registAddress",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider"),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }